import { jsx } from "react/jsx-runtime";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { tone } from "../../css/typography.css.mjs";
const Secondary = ({
  children,
  data,
  id,
  ...restProps
}) => /* @__PURE__ */ jsx(
  "span",
  {
    className: tone.secondary,
    id,
    ...buildDataAttributes({ data, validateRestProps: restProps }),
    children
  }
);
export {
  Secondary
};
